import { render, staticRenderFns } from "./NomenclatureMultiSelect.vue?vue&type=template&id=1310fa3d&"
import script from "./NomenclatureMultiSelect.vue?vue&type=script&lang=js&"
export * from "./NomenclatureMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports